const ReturnsPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* כותרת ראשית */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#9a624b] via-[#ac609c] to-[#9a624b] bg-clip-text text-transparent mb-4">
            מדיניות החזרות
          </h1>
          <p className="text-gray-600 text-xl">
            אנו מאמינים באיכות המוצרים שלנו ומבטיחים שביעות רצון מלאה
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#9a624b] to-[#ac609c] mx-auto rounded-full mt-6"></div>
        </div>

        {/* מדיניות החזרות */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">תנאי החזרה</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">תקופת החזרה</h3>
              <p className="leading-relaxed">
                אנו מקבלים החזרות תוך 14 ימים ממועד הרכישה, בתנאי שהמוצר במצב חדש ולא נפגם.
                המוצר חייב להיות באריזה המקורית שלו עם כל התכולה.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">מוצרים שאינם ניתנים להחזרה</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>מוצרים מותאמים אישית או בהזמנה מיוחדת</li>
                <li>מוצרים שניזוקו או שונו על ידי הלקוח</li>
                <li>מוצרים שפג תוקפם או שאינם במצב חדש</li>
                <li>תכשיטים עם אבנים יקרות שטופלו או שונו</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">תהליך ההחזרה</h3>
              <ol className="list-decimal list-inside space-y-2">
                <li>צרו קשר עם שירות הלקוחות בטלפון או באימייל</li>
                <li>ציינו את מספר ההזמנה וסיבת ההחזרה</li>
                <li>שלחו את המוצר באריזה המקורית</li>
                <li>נבדוק את המוצר ונאשר את ההחזרה</li>
                <li>נחזיר את הכסף תוך 7-14 ימי עסקים</li>
              </ol>
            </div>
          </div>
        </div>

        {/* החזרת כספים */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">החזרת כספים</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">זמני החזרה</h3>
              <p className="leading-relaxed">
                החזרת הכסף תתבצע תוך 7-14 ימי עסקים ממועד קבלת המוצר בחזרה.
                ההחזרה תתבצע באותה שיטת תשלום שבה בוצעה הרכישה.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">עלויות משלוח</h3>
              <p className="leading-relaxed">
                עלויות המשלוח של המוצר חזרה אלינו הן על חשבון הלקוח.
                במקרה של מוצר פגום או שגיאה שלנו, נשפה את עלויות המשלוח.
              </p>
            </div>
          </div>
        </div>

        {/* החלפת מוצרים */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">החלפת מוצרים</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">תנאי החלפה</h3>
              <p className="leading-relaxed">
                אנו מאפשרים החלפת מוצרים תוך 14 ימים ממועד הרכישה.
                המוצר החדש חייב להיות באותו ערך או גבוה יותר.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">הבדלי מחיר</h3>
              <p className="leading-relaxed">
                אם המוצר החדש יקר יותר, הלקוח ישלם את ההפרש.
                אם המוצר החדש זול יותר, נחזיר את ההפרש ללקוח.
              </p>
            </div>
          </div>
        </div>

        {/* יצירת קשר */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">צריכים עזרה?</h2>
          <div className="grid md:grid-cols-2 gap-8 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">פרטי קשר</h3>
              <div className="space-y-3">
                <p><strong>טלפון:</strong> 053-3332127</p>
                <p><strong>אימייל:</strong> nataly@sha-sha.co.il</p>
                <p><strong>שעות פעילות:</strong> א׳-ה׳ 09:00-19:00, ו׳ 09:00-14:00</p>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">מידע נוסף</h3>
              <div className="space-y-3">
                <p>• בדיקת מוצרים תתבצע תוך 3-5 ימי עסקים</p>
                <p>• החזרת כספים תתבצע תוך 7-14 ימי עסקים</p>
                <p>• משלוח החלפות חינם בקנייה מעל 299₪</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnsPolicyPage; 